import cookie from 'react-cookies'
import { COOKIES_TO_PURGE_ON_LOGIN } from './sessionProfileStore'

const COOKIE_OPTIONS = { path: '/' }

/** Elimina cookies de sesión obsoletas del cliente para que DevTools no falsifique RBAC ni datos personales. */
export function purgeSessionCookiesOnLogin() {
  COOKIES_TO_PURGE_ON_LOGIN.forEach((key) => {
    cookie.remove(key, COOKIE_OPTIONS)
  })
}
